import { apiAction, API_ERROR, API_SUCCESS } from "../dux/api";
import { apiCallComplete, apiCallStart } from "../dux/apiStatus";
import { SEND_FEEDBACK, FETCH_FEEDBACKS } from "../dux/feedback";
import { openSnackbar } from "../dux/snackbar";
import { getUserFeedbackUrl, getUserFeedbacksUrl } from "../helpers/apiEndPoints";

const feedback = () => (next) => (action) => {
  next(action);

  if (action.type === SEND_FEEDBACK) {
    const { feedback } = action.payload;
    next(apiCallStart({ api: "sendFeedback" }));
    next(
      apiAction({
        url: getUserFeedbackUrl(),
        feature: SEND_FEEDBACK,
        method: "POST",
        data: { feedback },
      })
    );
  }

  if (action.type === `${SEND_FEEDBACK} ${API_SUCCESS}`) {
    next(apiCallComplete({ api: "sendFeedback" }));
    next(
      openSnackbar({
        message: "Feedback has submitted successfully.",
      })
    );
  }

  if (action.type === `${SEND_FEEDBACK} ${API_ERROR}`) {
    next(apiCallComplete({ api: "sendFeedback" }));
  }

  if (action.type === FETCH_FEEDBACKS) {
    const { page = 1, limit = 20 } = action.payload || {};
    next(apiCallStart({ api: "fetchFeedbacks" }));
    next(
      apiAction({
        url: getUserFeedbacksUrl(),
        feature: FETCH_FEEDBACKS,
        method: "GET",
        data: { page, limit },
      })
    );
  }

  if (action.type === `${FETCH_FEEDBACKS} ${API_SUCCESS}` || action.type === `${FETCH_FEEDBACKS} ${API_ERROR}`) {
    next(apiCallComplete({ api: "fetchFeedbacks" }));
  }
};

export default feedback;
